<template>
    <div class="chat-message-item" :class="source.updating ? 'chat-message-item-updating' : ''">
      <div class="chat-message-item-time">{{ UTILS.getTimeInfoByTimeStamp(source.f_time) }}</div>
      <!-- 我发送的消息部分 -->
      <div class="chat-message-item-ask dsp-flex" v-if="source.ask">
        <div class="chat-message-item-content content-right">
          <p v-html="UTILS.getBreakLineTwoByText(source.ask)"></p>
        </div>
        <div class="chat-message-item-avatar">
          <img v-bind:src="userData && userData.avatar && userData.avatar != '' ? userData.avatar : dAvatar" alt="">
        </div>
      </div>
      <!-- 返回的消息部分 -->
      <div class="chat-message-item-reponse dsp-flex">
        <div class="chat-message-item-avatar">
          <img src="../../../assets/images/deepseek/avatar-ds.png" alt="">
        </div>
        <div class="chat-message-item-content">
          <p class="chat-message-item-title">{{ source.updating ? '思考中...' : '已深度思考' }}<i class="iconfont icon-xiangshang"></i></p>
          <div class="chat-message-item-reasoning-content" v-if="source.reasoning_content">
            <p v-html="UTILS.getBreakLineTwoByText(source.reasoning_content)"></p>
          </div>
          <div class="chat-message-item-main-content" v-if="source.content">
            <vue-markdown class="chat-message-item-md-content" :source="source.content"></vue-markdown>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
import { UTILS } from '../../../modules/utils'
import VueMarkdown from 'vue-markdown';
export default {
    name: 'ChatMessageItem',
    components: {
      VueMarkdown
    },  
    data() {
      return {
        UTILS: UTILS,
        dAvatar: 'https://m1.yxdxt.com/d.png'
      }
    },
    props: {
      source: {
        type: Object,
        default() { return {} },
        required: true
      }
    },
    computed: {
      userData() {
          return this.$store.state.userData ? this.$store.state.userData.info : {};
      },
    }
  }
  </script>
  
  <style scoped>
  .chat-message-item {
    padding: 10px;
  }
  .chat-message-item-updating {
    padding-bottom: 30px;
  }
  .chat-message-item-content {
    width: 88%;
  }
  .chat-message-item-ask {
    justify-content: flex-start;
  }
  .chat-message-item-reponse {
    justify-content: flex-end;
    padding-top: 0.5rem;
  }
  .chat-message-item-avatar {
    width: 12%;
    text-align: center;
  }
  .chat-message-item-avatar img{
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
  }
  .chat-message-item-avatar img{
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
  }
  .chat-message-item-content.content-right {
    text-align: right;
  }
  .chat-message-item-content.content-right p {
    padding: 10px;
    background: #EAF3FF;
    border-radius: 10px;
    display: inline-block;
    margin: 0;
  }
  .chat-message-item-title, .chat-message-item-title i {
    font-size: 0.85rem;
    color: #737373;
    margin: 0;
  }
  .chat-message-item-title i {
    display: inline-block;
    font-size: 0.75rem;
    transform: scale(0.7);
  }
  .chat-message-item-reasoning-content { 
    padding: 10px;
    color: #737373;
    border-left: solid 2px #E5E5E5;
    text-align: justify;
  }
  .chat-message-item-main-content {
    padding: 10px;
    text-align: justify;
  }
  .chat-message-item-md-content p {
    margin: 0;
    padding-top: 0.5rem !important;
  }
  .chat-message-item-time {
    text-align: center;
    font-size: 0.75rem;
    color: #737373;
    padding: 0.5rem 0;
  }
  </style>